import axios from '@/plugins/axios';

const INQUIRY_CATEGORY = '/inquiry-categories';
const POST_INQUIRY = '/inquiry';

export async function getInquiryCategoryList() {
  try {
    const { data } = await axios.get(`${INQUIRY_CATEGORY}`);
    return data;
  } catch (error) {
    return {
      error,
    };
  }
}

export async function postInquiry(params) {
  try {
    const { data } = await axios.post(`${POST_INQUIRY}`, params);
    return data;
  } catch (error) {
    return {
      error,
    };
  }
}
